import { call, put } from 'redux-saga/effects';
import ActionTypes from '@ziynx/action-types';
import { eventNames } from '@ziynx/analytics';
import type { ResponseAction } from '@ziynx/flow-types/media';
import type { MongoId } from '@ziynx/flow-types/globals';

type GetCompanyAction = {
  type: string,
  forceTokenRefresh: boolean,
  id: MongoId | 'me',
  type: string,
}

type PostCompanyAction = {
 id: MongoId | 'me',
 body: {
   name: string,
 },
};

type PatchCompanyAction = {
  type: string,
  id: MongoId | 'me',
  type: string,
  body: [
    {
      op: 'add' | 'replace' | 'remove',
      path: 'profileImage' | 'name' | string,
      value: string,
    }
  ]
};

export function* postCompany(action: PostCompanyAction): Generator<any, void, empty> {
  const actionId = action?.id || 'me';
  try {
    const response: {
      name: string,
      userPoolGroups: Array<string>,
    } = yield call(() => APIService.apiRequest('POST_COMPANY', 'POST', {
      body: action?.body ?? {},
    }));

    yield put({
      type: ActionTypes.auth.refreshToken,
      refreshToken: true,
    });

    // If there are changes within cognito:groups this will push the update
    yield call(() => APIService.getToken());

    yield put({
      type: ActionTypes.company.post.SUCCESS,
      id: actionId,
      response,
    });

    yield put({
      type: ActionTypes.analytics.logEvent.START,
      name: eventNames.onboarding_completed_company_details,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.company.post.ERROR,
      id: actionId,
      error,
    });
    yield put({
      type: ActionTypes.analytics.logEvent.START,
      name: eventNames.onboarding_completed_company_details_error,
    });
  }
}

export function* getCompany(action: GetCompanyAction): Generator<any, void, empty> {
  const actionId = action?.id ?? 'me';
  try {
    const response: {
      name: string,
      profileImage: ResponseAction,
      userPoolGroups: Array<string>,
    } = yield call(() => APIService.apiRequest('GET_COMPANY', 'GET', {
      routeParams: {
        id: actionId,
      },
    }));
    yield put({
      type: ActionTypes.company.get.SUCCESS,
      id: actionId,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.company.get.ERROR,
      id: actionId,
      error,
    });
  }
}

export function* patchCompany(action: PatchCompanyAction): Generator<any, void, empty> {
  const actionId = action?.id ?? 'me';
  try {
    const response: {
      name: string,
      profileImage: ResponseAction,
      userPoolGroups: Array<string>,
    } = yield call(() => APIService.apiRequest('PATCH_COMPANY', 'PATCH', {
      routeParams: {
        id: actionId,
      },
      body: action?.body ?? [],
    }));

    yield put({
      type: ActionTypes.company.patch.SUCCESS,
      id: actionId,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.company.patch.ERROR,
      id: actionId,
      error,
    });
  }
}

export function* patchCompanyImage(action: PatchCompanyAction): Generator<any, void, empty> {
  const actionId = action?.id ?? 'me';
  try {
    const response: {
      name: string,
      profileImage: ResponseAction,
    } = yield call(() => APIService.apiRequest('PATCH_COMPANY', 'PATCH', {
      routeParams: {
        id: actionId,
      },
      body: action?.body ?? [],
    }));

    yield put({
      type: ActionTypes.company.patchImage.SUCCESS,
      id: actionId,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.company.patch.ERROR,
      id: actionId,
      error,
    });
  }
}
